var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.sort !== 'none')?_c('span',{staticClass:"sortable-caret",class:{ disabled: _vm.disabled }},[_c('i',{staticClass:"sort-caret ascending",class:{ 'ascending-active': _vm.sort === 'asc' }}),_c('i',{staticClass:"sort-caret descending",class:{ 'descending-active': _vm.sort === 'desc' }})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }